import { render, staticRenderFns } from "./cardProjectGallery.vue?vue&type=template&id=1d72b506&scoped=true"
import script from "./cardProjectGallery.vue?vue&type=script&lang=js"
export * from "./cardProjectGallery.vue?vue&type=script&lang=js"
import style0 from "./cardProjectGallery.vue?vue&type=style&index=0&id=1d72b506&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d72b506",
  null
  
)

export default component.exports